<template>
    <div class="nav-list nano">
        <toast></toast>
        <el-menu
                class="nano-content"
                text-color="#6C757D"
                :default-openeds="openeds"
        >
            <div v-for="(item, index) in valueList" :key="index">
                <el-submenu :index="item.k && item.k.columnItem ? item.k.columnItem: ''" v-if="item.v&&item.v.length">
                    <template slot="title">
                        <span class="title">{{item.k && item.k._name ? item.k._name: ''}}</span>
                    </template>
                    <template>
                        <el-menu-item
                                v-for="(child, ind) in item.v" :key="child.key"
                                :index="child.key" v-show="ind < 3 || item.isShow"
                                :class="{'active': isActive(child, item,activeArr)}">
                            <div class="item-wrap">
                                <div class="text-content" @click="selectItem(child, item)"
                                     :title="child.value + '(' + child.aggSum +')'">
                                    <div class="text"> {{overflowText(child.value)}}</div>
                                    <div>(
                                        <span class="num">{{child.aggSum || '0' |numToMoneyField }}</span>
                                        )
                                    </div>
                                </div>
                                <!--                <span @click="deleteItem(child, item)" v-if="isActive(child, item)" class="close-icons"><i-->
                                <!--                  class="fa fa-close"></i></span>-->
                            </div>
                        </el-menu-item>
                        <!--            <select-bar v-if="item.k.columnItem === 'published'" class="select-bar"-->
                        <!--                        :value="changeItem(item.v)"></select-bar>-->
                    </template>
                    <div class="look-more text-primary" @click="lookMore(index)" v-if="item.v && item.v.length > 3">
                        {{item
                        .isShow?'Retract':'More'}}
                    </div>
                </el-submenu>
            </div>
        </el-menu>
    </div>
</template>

<script>
import * as _ from 'lodash'
import SelectBar from './selectBar'
import MixinUpdateData from '@/views/TheHome/mixins/updateData'
import Toast from '../../toast/Toast'

export default {
  name: 'navList',
  components: {Toast, SelectBar},
  mixins: [MixinUpdateData],
  props: {
    value: {
      type: Array
    }
  },
  data () {
    return {
      echarts: [],
      activeArr: [], // 需要高亮的key
      filterArr: [] // 需要筛选的数组
      // openeds: []
    }
  },
  computed: {
    valueList () {
      return this.value
    },
    openeds () {
      let arr = []
      _.forEach(this.valueList, (item) => {
        if (item.k && item.k.columnItem) {
          arr.push(item.k.columnItem)
        }
      })
      return arr
    }
  },
  mounted () {
    this.$eventBus.$on('searchSub', (data) => {
      this.eventSearchSub(data)
    })
    this.$nextTick(() => {
      setTimeout(() => {
        this.updateEcharts()
      })
    })
  },
  methods: {
    overflowText (val, item) {
      const text = val.length > 9 ? val.substring(0, 9) + '...' : val
      return text || '---'
    },
    selectItem (val, pVal) {
      if (this.isActive(val, pVal, this.activeArr)) {
        this.deleteItem(val, pVal)
        return
      }
      const arr = _.filter(pVal.v, (item) => {
        return _.indexOf(this.activeArr, item.key + ',' + pVal.k.columnItem) !== -1
      })
      if (arr.length) {
        this.activeArr = _.filter(this.activeArr, (item) => {
          return item !== arr[0].key + ',' + pVal.k.columnItem
        })
        this.filterArr = _.filter(this.filterArr, (item) => {
          return item.v[0] !== arr[0].key
        })
      }
      let vals = {
        d: '0',
        k: pVal.k.columnItem,
        v: [val.key]
      }
      // 为时间做特殊逻辑
      if (pVal.k.name === '时间') {
        vals = {
          d: '1',
          k: 'published',
          v: [`${val.key}-01-01`, `${val.key}-12-31`]
        }
        this.filterArr = _.filter(this.filterArr, (item) => {
          return item.k !== vals.k
        })
      }
      this.filterArr.push(vals)
      this.activeArr.push(val.key + ',' + pVal.k.columnItem)
      this.$emit('selectItem', this.filterArr)
    },
    lookMore (index) {
      this.$set(this.valueList[index], 'isShow', !this.valueList[index].isShow)
    },
    changeItem (val) {
      let series = []
      let xAxis = []
      _.forEach(val, (item) => {
        series.push(item.aggSum)
        xAxis.push(item.key)
      })
      const value = {
        series,
        xAxis
      }
      return value
    },
    deleteItem (val, pVal) {
      this.activeArr = _.filter(this.activeArr, (item) => {
        return item !== val.key + ',' + pVal.k.columnItem
      })
      this.filterArr = _.filter(this.filterArr, (item) => {
        return item.v[0] !== val.key
      })
      if (pVal.k.name === '时间') {
        this.filterArr = _.filter(this.filterArr, (item) => {
          return item.k !== pVal.k.columnItem
        })
      }
      this.$emit('selectItem', this.filterArr)
    },
    isActive (val, pVal, arr) { // 判断是否应该高亮
      return _.indexOf(arr, val.key + ',' + pVal.k.columnItem) !== -1
    },
    clearFilter () {
      this.activeArr = []// 需要高亮的key
      this.filterArr = [] // 需要筛选的数组
    },
    eventSearchSub (data, type = 'catName.keyword') {
      let iteVal = null
      const pVal = _.find(this.value, (item) => {
        if (item.k.columnItem === type) {
          iteVal = _.find(item.v, ['value', data])
          if (iteVal) {
            return item
          } else {
            return undefined
          }
        }
      })
      if (iteVal && pVal) {
        this.selectItem(iteVal, pVal)
      } else {
        $('.wrap').text(type ? '无匹配研报类型' : '无匹配二级栏目搜索')
        $('.wrap').show().delay(1500).hide(100)
      }
    }
  },
  filters: {
    numToMoneyField (inputString) {
      if (inputString) {
        let regExpInfo = /(\d{1,3})(?=(\d{3})+(?:$|\.))/g
        var ret = inputString.toString().replace(regExpInfo, '$1,')
        return ret
      }
      return inputString
    }
  }
}
</script>

<style scoped lang="scss">
    .nav-list {
        width: 100%;
        height: 100%;

        /deep/ .el-menu {
            height: 100%;
            right: 0;

            .el-submenu__title {
                display: flex;
                justify-content: space-between;
                align-items: center;
                height: auto !important;
                max-height: 63px;
                line-height: 18px;
                margin: 0 0 10px 0;

                &:hover {
                    background: #ffffff;
                }

                .title {
                    transform: translateX(0) !important;
                    word-wrap: break-word;
                    white-space: pre-wrap;
                }
            }

            .title {
                position: static !important;
                width: calc(100% - 12px);
            }

            .look-more {
                padding: 0 20px;
                font-size: 14px;
                margin-bottom: 18px;
                cursor: pointer;
            }

            .title {
                color: #303133;
                font-size: 16px;
                font-weight: bolder;
            }

            .close-icons {
                width: 10px;
                display: flex;
                align-items: center;
                justify-content: center;
            }

            .el-submenu {

                .el-menu-item {
                    min-width: 0;
                    height: 36px;
                    line-height: 36px;
                    padding: 0 20px !important;
                    border-bottom: 2px solid transparent;

                    i {
                        color: #303133;
                        font-size: 14px;
                    }

                    .item-wrap {
                        width: 100%;
                        display: flex;
                        height: 36px;
                        align-items: center;
                        -webkit-user-select: none;
                        -moz-user-select: none;
                        -ms-user-select: none;
                        user-select: none;
                    }

                    .text-content {
                        width: 100%;
                        line-height: 15px;
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        border-bottom: 2px solid transparent;

                        .text {
                            width: calc(100% - 50px);
                            /*overflow: hidden; //超出的文本隐藏*/
                            /*text-overflow: ellipsis; //溢出用省略号显示*/
                            /*white-space: nowrap; //溢出不换行*/
                        }

                        .num {
                            width: 40px;
                            overflow: hidden; //超出的文本隐藏
                            text-overflow: ellipsis; //溢出用省略号显示
                            white-space: nowrap; //溢出不换行
                        }
                    }

                    &:focus, &:hover {
                        background: #208eff2b;
                        color: #303133;
                    }

                    &.active {
                        background: #208eff2b !important;
                        color: #208EFF !important;
                        font-weight: bolder;

                        .text-content {
                            /*border-color: #208EFF;*/
                        }

                        /*color: #208EFF !important;*/
                    }

                    &.is-active {
                        background: #ffffff;
                        color: #6C757D;
                    }
                }
            }

        }

        .icons {
            width: 5px;
        }

        .select-bar {
            width: 160px;
            height: 200px;
        }
    }
</style>
